import React from "react";

const Logout = ( { parentUrl } ) => {
    console.log("Parent Url in Logout Component: ", parentUrl);
    const login = () => {
        const jsonData = {
            app: "Rxcopilot",
            action: "flex-relogin",
            url:window.appConfig.oauth.redirectUrl
          };
          window.parent.postMessage(
            jsonData,
            parentUrl
          );
    }
    
    return (
        <div className="logoutBtnDiv">
          <button className="logoutBtn" onClick={login}>
            Log In Again
        </button>
        </div>
    )
};

export default Logout;
    